import { main } from '@/main'
import axios from 'axios'
import util from '@/util'
import store from '../store'
import mensagens from '@/util/mensagens'
import constants from './constants'
import * as authStorage from '@/modules/auth/storage'

const estaEmModoDev = () => {
  const modoDev = process.env.VUE_APP_DEV_MODE
  if (!util.valorVazio(modoDev)) {
    return (modoDev === 'true')
  }
  return false
}

const obterDominio = () => {
  const hostName = window.location.host
  const dominios = [
    { url: process.env.VUE_APP_OFFICE_ADV_DOMAIN },
    { url: process.env.VUE_APP_MIRT_DOMAIN }
  ]

  for (const indice in dominios) {
    const dominioIteracao = dominios[indice]
    if (!util.valorVazio(dominioIteracao.url) && hostName.includes(dominioIteracao.url)) {
      return dominioIteracao.url
    }
  }

  const dominio = hostName.split(':')[0]
  return dominio
}

const obterUrlApi = () => {
  const hostName = window.location.host
  const dominios = [
    { url: process.env.VUE_APP_OFFICE_ADV_DOMAIN, callback: () => { return obterUrlApiLegacy() } },
    { url: process.env.VUE_APP_MIRT_DOMAIN, callback: () => { return obterUrlApiManagerConfig() } }
  ]

  for (const indice in dominios) {
    const dominio = dominios[indice]
    if (!util.valorVazio(dominio.url) && hostName.includes(dominio.url)) {
      const callback = dominio.callback
      const urlCallback = callback()
      if (!util.valorVazio(urlCallback)) {
        return urlCallback
      }
      return obterUrlApiLegacy()
    }
  }

  return obterUrlApiLegacy()
}

const obterUrlApiLegacy = () => {
  const hostName = window.location.host
  let url = process.env.VUE_APP_MANAGER_API_BASE_URL
  if (hostName === process.env.VUE_APP_ALTERNATIVE_HOST_NAME) {
    url = process.env.VUE_APP_MANAGER_API_ALTERNATIVE_URL
  }

  return url
}

const obterUrlApiManagerConfig = () => {
  const hostName = window.location.host
  let url = process.env.VUE_APP_MIRT_API_BASE_URL
  if (hostName === process.env.VUE_APP_MIRT_ALTERNATIVE_HOST_NAME) {
    url = process.env.VUE_APP_MIRT_API_ALTERNATIVE_URL
  }

  return url
}

const obterNomeRotaDefault = () => {
  const hostName = window.location.host
  const dominios = [
    { url: process.env.VUE_APP_OFFICE_ADV_DOMAIN, rota: constants.nomeRotaLogin },
    { url: process.env.VUE_APP_MIRT_DOMAIN, rota: constants.nomeRotaLoginLite }
  ]

  for (const indice in dominios) {
    const dominio = dominios[indice]
    if (!util.valorVazio(dominio.url) && hostName.includes(dominio.url)) {
      return dominio.rota
    }
  }

  const rotaDefault = process.env.VUE_APP_DEFAULT_ROUTE
  if (!util.valorVazio(rotaDefault)) {
    return rotaDefault
  }

  return constants.nomeRotaLogin
}

const controleRefreshPagina = () => {
  if (controleRefreshPaginaEstaHabiliado()) {
    executarControleRefreshPagina()
  }
}

const controleRefreshPaginaEstaHabiliado = () => {
  const controleRefreshPagina = process.env.VUE_APP_CONTROLE_REFRESH_PAGINA
  if (util.valorVazio(controleRefreshPagina) || controleRefreshPagina === 'true') {
    return true
  }
  return false
}

const executarControleRefreshPagina = () => {
  const dataHoje = util.formatarData(new Date(), 'YYYY-MM-DD')
  const dataRefreshPagina = authStorage.getDataRefreshPagina()
  if (!util.valorVazio(dataRefreshPagina)) {
    if (verificarNecessidadeRefreshPagina(dataRefreshPagina, dataHoje)) {
      realizarRefreshPagina(dataHoje)
    }
  } else {
    authStorage.setDataRefreshPagina(dataHoje)
  }
}

const verificarNecessidadeRefreshPagina = (dataRefreshPagina, dataHoje) => {
  if (dataRefreshPagina !== dataHoje) {
    return true
  }
  return false
}

const realizarRefreshPagina = (dataHoje) => {
  authStorage.setDataRefreshPagina(dataHoje)
  window.location.reload()
}

const downloadDeArquivoViaCloud = async (cloudUrl) => {
  try {
    const resposta = await axios.get(cloudUrl, {
      responseType: 'blob',
      transformRequest: (data, headers) => {
        if (!util.valorVazio(headers.common['Authorization'])) {
          delete headers.common['Authorization']
        }
        return data
      } })
    return Promise.resolve(resposta)
  } catch (e) {
  }
  return null
}

const tratar201 = (response) => {
  if (!util.valorVazio(response.headers['x-cloud-download-url'])) {
    let resultadoDownload = downloadDeArquivoViaCloud(response.headers['x-cloud-download-url'])
    if (resultadoDownload === null) {
      resultadoDownload = Promise.reject(response)
    }
    return resultadoDownload
  }
  return Promise.resolve(response)
}

const tratar401 = (responseError) => {
  store.dispatch('auth/ActionSignOut')
  const rotaAtual = window._Vue.$router.app._route.name
  const nomeRotaDefault = obterNomeRotaDefault()
  if (rotaAtual !== nomeRotaDefault) {
    window._Vue.$intercom.shutdown()
    window._Vue.$router.push({ name: nomeRotaDefault }, util.criarAlertaToastDeErro(main, 'Aviso', responseError.response.data.message))
  }
  return Promise.reject(responseError)
}

const tratar413 = (responseError) => {
  const backEndRetornouMensagem413 = !util.valorVazio(responseError.response.data.message)
  let mensagemStatus413 = null
  if (backEndRetornouMensagem413) {
    mensagemStatus413 = responseError.response.data.message
  } else {
    mensagemStatus413 = mensagens.mensagemStatus413
  }
  util.criarAlertaToastDeErro(main, 'Aviso', mensagemStatus413)
  return Promise.reject(responseError)
}

const obterTituloPagina = () => {
  const hostName = window.location.host
  const titulo = Object.entries(constants.tituloPadraoDePagina).find(([empresa]) => hostName.includes(empresa))

  if (titulo) return titulo[1]

  return constants.tituloPadraoDePagina.office
}

export default {
  obterUrlApi,
  controleRefreshPagina,
  tratar201,
  tratar401,
  tratar413,
  downloadDeArquivoViaCloud,
  obterNomeRotaDefault,
  estaEmModoDev,
  obterUrlApiLegacy,
  obterUrlApiManagerConfig,
  obterTituloPagina,
  obterDominio
}
